import { render } from "./MyGoods.vue?vue&type=template&id=29bd9c8e&scoped=true"
import script from "./MyGoods.vue?vue&type=script&lang=js"
export * from "./MyGoods.vue?vue&type=script&lang=js"

import "./MyGoods.vue?vue&type=style&index=0&id=29bd9c8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bd9c8e"]])

export default __exports__